import SecaoCapa from '../secaoCapa';
import SecaoProdutos from '../secaoProdutos/';
import SecaoContatos from '../secaoContato/';
import SecaoSobre from '../secaoSobre/';

export default function Conteudo () {
    return (
        <main>
            <SecaoCapa />
            <SecaoProdutos />
            <SecaoSobre />
            <SecaoContatos />
        </main>
    )
}